<template>
  <div class="shareIndex">
    <div class="logo LeftBottom"><img src="../assets/logo.png" alt=""></div>
    <div class="mapCon Center">
      <div class="map">
        <div class="map_bg">
          <img src="../assets/1/map750.png" class="wid100" alt="">
        </div>
        <div class="title End">
          <img src="../assets/1/1.png" class="wid100" alt="">
        </div>
        <div class="map_mask">
          <img src="../assets/1/mask.png" class="hei100" alt="">
        </div>
        <div class="LootBox">
          <div v-for="box in displayBoxes" :key="box.id" class="box"  :style="{ top: box.top, left: box.left, position: 'absolute' }">
            <img :src="getBoxImage(box.id)" :data-id="box.id" class="boxImg" alt="">
            <img src="../assets/1/2.png" class="light" alt="">
          </div>
        </div>

      </div>

    </div>
    <div class="binocle">
      <img src="../assets/1/binocle.png" class="wid100" alt="">
    </div>
    <div class="share Center">
      <div class="share_box">
        <img src="../assets/share.png" class="hei100" alt="">
        <img src="../assets/share1.jpg" class="imgObj" alt="">

        <div class="shareBtn">
          <img src="../assets/btn/share.png" @click="showTips"   alt="">
          <p><img src="../assets/btn/close.png" style="width: 11%;" @click="handleClose"  alt=""></p>
        </div>
      </div>
    </div>

    <div class="shareTips" v-if="shareTips">
      <div class="logo LeftBottom"><img src="../assets/logo.png" alt=""></div>
      <div class="drawTipsBox" @click="shareType">
        <img src="../assets/weixin.png">
      </div>
    </div>


    <div class="shareRes" v-if="shareRes">
      <div class="shareResBox Center">
        <div class="box">
          <img src="../assets/draw/2.png" class="wid100">
          <div class="shareResBody">
            <div class="claimed-info" v-if="shareResType==1">
              <p class="claimed-text" >您已分享成功获得一次抽奖机会</p>
              <p class="claimed-text result-highlight">返回首页即可抽奖</p>
            </div>
            <div class="claimed-info" v-if="shareResType==2">
              <p class="claimed-text" >您的抽奖机会已使用完毕</p>
              <p class="claimed-text result-highlight">抽奖结果为：{{prizeName}}</p>
              <p class="claimed-text ">点击【我的奖品】即可查看中奖结果</p>
              <p class="claimed-text">感谢您的参与</p>
            </div>
            <div class="close-btn">
              <img src="../assets/btn/home.png" @click="toHome" alt="返回首页">
            </div>
          </div>


        </div>

      </div>
    </div>

  </div>
</template>

<script>


import '@/store' // 确保 setActivePinia 在此处生效
import {reqShare,reqUserInfo } from '@/api';
const positions = [
  { top: '5%', left: '0%',url:require('../assets/card/2/1.png') },
  { top: '0%', left: '34%',url:require('../assets/card/2/2.png') },
  { top: '20%', left: '19%',url:require('../assets/card/2/3.png') },
  { top: '21%', left: '54%',url:require('../assets/card/2/4.png')},
  { top: '35%', left: '0%' ,url:require('../assets/card/1/1.png')},
  { top: '41%', left: '35%',url:require('../assets/card/1/2.png') },
  { top: '40%', left: '60%',url:require('../assets/card/1/3.png') },
  { top: '54%', left: '23%',url:require('../assets/card/1/4.png')},
  { top: '60%', left: '3%',url:require('../assets/card/1/5.png') },
  { top: '59%', left: '60%',url:require('../assets/card/1/6.png') },
  { top: '73%', left: '38%',url:require('../assets/card/1/7.png') }
]

// 洗牌算法
function shuffleArray(arr) {
  const a = [...arr]
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[a[i], a[j]] = [a[j], a[i]]
  }
  return a
}

// 为每个箱子随机分配位置
function createRandomBoxes() {
  const shuffledPositions = shuffleArray(positions)
  return shuffledPositions.map((pos, index) => ({
    id: index + 1,
    ...pos
  }))
}

export default {
  name: "index",
  components: {},
  data() {
    return {
      displayBoxes: createRandomBoxes(), // 每个箱子随机分配一个位置
      clickedBoxIds: [],
      shareTips:false,
      shareRes:false,
      shareResType:0,
      prizeName:""

    }
  },


  created() {

  },
  mounted() {

  },

  methods: {

    //关闭分享弹窗后，判断结果
    shareType(){
      reqShare().then(res=>{
        if(res.code==200){
          this.shareResType = 1;
        }
        if(res.code==500){
          this.shareResType = 2;
          reqUserInfo().then(res=>{
            this.prizeName = res.data.prizeName
          })
        }

        this.shareRes = true;
        this.shareTips = false;
      })
    },

    handleClose() {
      this.$emit('close')
    },
    showTips(){
      this.shareTips = true;
    },
    toHome(){
      // this.$router.go(0)
      window.location.reload();

    },


    getBoxImage(id) {
      if (this.clickedBoxIds.includes(id)) {
        return require('../assets/1/boxopen/' + id + '.png')
      }
      return require('../assets/1/boxclose/' + id + '.png')
    },





  }
}
</script>

<style scoped>
.share{ width: 100%; height: 100%; background: rgba(0,0,0,0.8); position: absolute; top:0; z-index: 20;}
.share_box{ width: 100%; height: 70%; margin: -25% 0 0 0; text-align: center; position: relative;}
.shareBtn{position: absolute; bottom: -22%; width: 100%; text-align: center; z-index: 2}
.shareBtn img{width: 70%}
.boxImg {
  width: 100%;
}

.shareTips{width: 100%; height: 100%; overflow-y: auto; position: absolute; z-index: 30; top:0; left: 0; background: rgba(0,0,0,0.8)}
.shareTips .drawTipsBox{width: 100%; height: 90%; text-align: right}
.shareTips .drawTipsBox img{width: 50%;margin-right: 5%; }

.shareIndex {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: url("../assets/1/bg.jpg") center no-repeat;
  background-size: cover;
  position: fixed; top:0;left: 0;  z-index: 101
}

.imgObj{position: absolute; width: 100%; height: 100%; top:0; left: 0; opacity: 0;}
.shareRes{width: 100%; height: 100%; overflow-y: auto; position: absolute; z-index: 21; top:0; left: 0; background: rgba(0,0,0,0.8)}
.shareRes .shareResBox{width: 100%; height: 90%; text-align: right}
.shareRes .shareResBox .box{width: 90%; position: relative}
.shareRes .shareResBody{width: 100%;height: 100%; position: absolute; top:0;}
.shareRes .shareResBody .claimed-info{  position: absolute;top:12%;left: 0;width: 100%;text-align: center;}
.shareRes .shareResBody .claimed-text{    font-size: 1rem;
  color: #381d06;
  line-height: 1.2;}
.shareRes .shareResBody .result-highlight {
  font-weight: bold;
  background-image: linear-gradient(to bottom, #2c1504, #e43e1d);
  -webkit-background-clip: text;
  color: transparent;
  /* 抗锯齿和增强文字边缘 */
  -webkit-font-smoothing: antialiased;
}

/* 关闭按钮 */
.close-btn {
  position: absolute;
  bottom: -10%;
  right: 8px;
  width: 100%;
  z-index: 10;
  text-align: center;
  cursor: none;
}

.close-btn img {
  width: 50%;
}




.mapCon {
  width: 100%;
  height: 100%;
}

.mapCon .map {
  width: 100%;
  position: relative;
}

.mapCon .map .map_bg {
  width: 100%;
}

.mapCon .title {
  position: absolute;
  top: -9.5%;
  width: 100%;
  text-align: center;
  z-index: 2;
}

/*.mapCon .title{width: 100%; height: 24%; z-index: 2; position: relative;}*/
.mapCon .title img {
  width: 90%;
  margin-left: -1%;
}

.mapCon .map_mask {
  position: fixed;
  pointer-events: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.binocle {
  position: absolute;
  width: 30%;
  left: 0;
  bottom: 0;
  vertical-align: middle
}

.binocle img {
  vertical-align: middle
}

.LootBox {
  position: absolute;
  top: 16%;
  left: 10%;
  width: 80%;
  height: 75%;
  z-index: 2;
}

.LootBox .box {
  position: absolute;
  width: 45%;

}

.LootBox .box .boxImg {
  position: absolute;
  width: 34%;
  top: 27%;
  left: 33%;
  pointer-events: none;
}

.LootBox .box .light {
  width: 100%;
  pointer-events: none;
}



.map .manBtn img {
  width: 45%;
  margin: 0 -4%;
}

.mapCon .nav {
  position: absolute;
  right: 1%;
  top: 45%;
  text-align: center;
  width: 20%;
  z-index: 2;
}

.mapCon .nav span {
  display: inline-block;
  padding: 4% 12%;
  margin: 6% 0;
  vertical-align: middle;
  color: #fff;
  font-size: .85rem;
  background-color: #69431b;
  border-radius: 30px;
  cursor: pointer;
}

/* 淡入淡出过渡 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/share.vue